const EVENT_SEARCH = 'event-search';

const searchEventTrigger = () => {
	const currentPathname = window.location.pathname;
	if (currentPathname.includes('_txt-')) {
			const event = new CustomEvent(EVENT_SEARCH);
			document.dispatchEvent(event);
	}
};

export {EVENT_SEARCH, searchEventTrigger};